import { Link, Text, vars } from "@janeapp/burrito-design-system"
import { useTranslation } from "react-i18next"
import styled, { css } from "styled-components"
import { ReactComponent as JaneLogo } from "../../images/JaneLogo.svg"

const PRIVACY_POLICY_URL = "https://jane.app/legal/privacy-policy"
const TERMS_URL = "https://jane.app/legal/terms-of-use"

// Link carries the underline and link colour already, but sets no font size,
// so without this it would inherit the document default rather than 14px.
const FooterLink = styled(Link)(
  () => css`
    font-size: ${vars.global.typography.fontSize.md};
    line-height: ${vars.global.typography.lineHeight.md};
    letter-spacing: ${vars.global.typography.letterSpacing.md};
  `
)

export const AccountFooter = () => {
  const { t } = useTranslation()

  return (
    <footer className="mx-auto flex w-full max-w-[438px] flex-col items-center gap-2">
      {/* Both dimensions set explicitly: the design's 30x24.84 is not quite a
          proportional scale of the asset's 54x44. */}
      <JaneLogo width={30} height={24.84} />

      <Text size="md" color="subdued" className="text-center">
        {t("footer.description")}
      </Text>

      <div className="flex items-center gap-2">
        <FooterLink href={PRIVACY_POLICY_URL}>
          {t("footer.privacyPolicy")}
        </FooterLink>
        <Text elementType="span" size="md" color="subdued">
          &middot;
        </Text>
        <FooterLink href={TERMS_URL}>
          {t("footer.termsAndConditions")}
        </FooterLink>
      </div>
    </footer>
  )
}
